import { DefaultService } from '@/services/DefaultService';

export default class ValoresKmService extends DefaultService {

  constructor(http, router, env) {
      super(http, router, env);
  }
  
  save(form) {
    return this._http.post(`${this._env}/despesa/valorkm`, form, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }

  find(id) {
    return this._http.get(`${this._env}/despesa/valorkm/${id}.json`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }

  validacaoDeAcertoPadrao(idtipoveiculo) {
    return this._http.get(`${this._env}/despesa/valorkm/validacao/acertopadrao/${idtipoveiculo}.json`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }

  verificarPossibilidadeDesativacao(idtipoveiculo) {
    return this._http.get(`${this._env}/despesa/valorkm/validacao/desativacao/${idtipoveiculo}.json`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }

  getKmAtivo(idusuarioerp) {
    return this._http.get(`${this._env}/despesa/valorkm/getativo/${idusuarioerp}.json`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }

  getPrimeiro() {
    return this._http.get(`${this._env}/despesa/valorkm/primeiro`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }

  findAll(column, order, page, limit, situacao, params) {
    return this._http.get(encodeURI(`${this._env}/despesa/valorkm.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
    });
  }

  findAllCombo(...params) {
		return this._http.get(encodeURI(`${this._env}/despesa/getcombo/tipoveiculovalorkm.json?param=${params}`), this._headers).then(res => {
				return res.body;
		}, err => {
				this.verifyError(err);
				throw new Error('Problems while jobs are loading');
		});
	}

  findEnums() {
    return this._http.get(`${this._env}/despesa/valorkm/enums`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }

  changeSituacao(id, situacao) {
    return this._http.get(`${this._env}/despesa/valorkm/activate/${id}?situacao=${situacao}`, this._headers).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw err;
    });
  }

}